// CONSTANTS
const QUERY_STRING_KEYS = {
  PAGE_NUMBER: 'pageNumber',
  PAGE_SIZE: 'pageSize',
  SORT_BY: 'orderBy',
  FILTER: 'filter',
  VIEW: 'view',
  OPTION: 'option',
  LOCATION_TYPE: 'locationType'
}

const SORT_DELIMITER = ' '
const FILTER_DELIMITER = SORT_DELIMITER
const DISPLAY_FILTER_DELIMITER = ':'

export const SORT_TYPES = {
  DESCENDING: 'desc',
  ASCENDING: 'asc'
}

export const OPTIONS = {
  ACTIVE: 'active',
  BUNDLE: 'bundle'
}

export const sortTypeString = (descending) => descending ? SORT_TYPES.DESCENDING : SORT_TYPES.ASCENDING

const serializeFilter = (filter) => {
  const { filterType, operator, value, displayValue } = filter
  const baseFilterExpressionString = `${filterType}${FILTER_DELIMITER}${operator}${FILTER_DELIMITER}${typeof value !== 'undefined' ? value : ''}`
  const filterExpressionString = displayValue ? `${baseFilterExpressionString}${DISPLAY_FILTER_DELIMITER}${displayValue}` : baseFilterExpressionString

  return filterExpressionString
}

export const FilterRouter = {
  // VIEW
  applyView: function (view) {
    return {
      params: {
        [QUERY_STRING_KEYS.VIEW]: view
      }
    }
  },
  extractView: function (route) {
    const notFound = {}
    const view = route && route.params && route.params[QUERY_STRING_KEYS.VIEW]
    if (!view) return notFound
    return view
  },

  // SORTING
  applySortBy: function ({ sortKey, descending }) {
    const direction = descending ? SORT_TYPES.DESCENDING : SORT_TYPES.ASCENDING
    const sortBy = `${sortKey}${SORT_DELIMITER}${direction}`

    return {
      query: {
        [QUERY_STRING_KEYS.SORT_BY]: sortBy
      }
    }
  },
  extractSortBy: function (route) {
    const notFound = {}
    const sortByString = route && route.query && route.query[QUERY_STRING_KEYS.SORT_BY]
    if (!sortByString) return notFound

    const sortData = sortByString.split(SORT_DELIMITER)
    if (sortData.length !== 2) return notFound
    const sortKey = sortData[0]
    const descending = sortData[1] !== SORT_TYPES.ASCENDING
    return { sortKey, descending }
  },

  // PAGING
  applyPaging: function ({ page, size }) {
    return {
      query: {
        [QUERY_STRING_KEYS.PAGE_NUMBER]: page,
        [QUERY_STRING_KEYS.PAGE_SIZE]: size
      }
    }
  },
  extractPaging: function (route) {
    const notFound = {}
    const page = route && route.query && route.query[QUERY_STRING_KEYS.PAGE_NUMBER]
    const size = route && route.query && route.query[QUERY_STRING_KEYS.PAGE_SIZE]
    if (!page || !size) return notFound
    return { page, size }
  },

  // FILTERING
  applyFilters: function (filters) {
    return {
      query: {
        [QUERY_STRING_KEYS.FILTER]: filters.map(serializeFilter)
      }
    }
  },
  extractFilters: function (route) {
    let filters = (route && route.query && route.query[QUERY_STRING_KEYS.FILTER]) || []
    if (!Array.isArray(filters)) filters = [filters]
    const extractedFilters = filters.map(filter => {
      const filterArgs = {}
      filterArgs.filterType = filter.split(FILTER_DELIMITER)[0]
      filterArgs.operator = filter.split(FILTER_DELIMITER)[1]
      filterArgs.value = filter.split(DISPLAY_FILTER_DELIMITER)[0].split(FILTER_DELIMITER).slice(2).join(FILTER_DELIMITER)
      filterArgs.displayValue = `${filter.split(DISPLAY_FILTER_DELIMITER).slice(1).join(DISPLAY_FILTER_DELIMITER)}`
      return filterArgs
    })
    return extractedFilters
  },

  // OPTION
  applyOption: function (option) {
    return {
      query: {
        [QUERY_STRING_KEYS.OPTION]: option
      }
    }
  },
  extractOption: function (route) {
    const notFound = {}
    const option = route && route.query && route.query[QUERY_STRING_KEYS.OPTION]
    if (!option) return notFound
    return option
  },

  // LOCATION_TYPE
  applyLocationType: function (locationType) {
    return {
      query: {
        [QUERY_STRING_KEYS.LOCATION_TYPE]: locationType?.toLowerCase()
      }
    }
  },
  extractLocationType: function (route) {
    const option = route && route.query && route.query[QUERY_STRING_KEYS.LOCATION_TYPE]
    if (!option) return null
    return option
  },

  // EXTRACT
  extractAll: function (route) {
    const view = this.extractView(route)
    const paging = this.extractPaging(route)
    const sortBy = this.extractSortBy(route)
    const filters = this.extractFilters(route)
    const option = this.extractOption(route)
    const locationType = this.extractLocationType(route)
    return {
      view,
      ...paging,
      ...sortBy,
      filters,
      option,
      locationType
    }
  },

  // ROUTING
  updateRoute: function (route, { params: paramsToUpdate, query: queryToUpdate }) {
    const { name, params, query } = route
    const updatedParams = Object.assign({}, params, paramsToUpdate)
    const updatedQuery = Object.assign({}, query, queryToUpdate)
    return { name, params: updatedParams, query: updatedQuery }
  }
}
